import { motion } from "framer-motion";
import ContactForm from "../../Components/ContactForm/ContactForm";
import SectionTitle from "../../Components/SectionTitle/SectionTitle";
import { fadeIn, staggerContainer } from "../../Constants/FramerMotions";
import "./contact.scss";

const Contact = () => {
  return (
    <motion.div
      className="contact-container"
      id="Contact"
      variants={staggerContainer}
      initial="hidden"
      whileInView="show"
      viewport={{ once: false, amount: 0.25 }}
    >
      <div className="blur p-blur1" style={{ background: "#ABF1FF94" }}></div>

      <div className="contact-header">
        <motion.div
          variants={fadeIn("right", "tween", 0.1, 0.4)}
          style={{ width: "100%" }}
        >
          <SectionTitle title="Contact" subtitle="Get In Touch" />
        </motion.div>
      </div>

      <div className="contact-form-container">
        <motion.div variants={fadeIn("left", "tween", 0.1, 0.4)}>
          <ContactForm />
        </motion.div>
      </div>

      <div
        className="blur c-blur1"
        style={{ background: "rgb(238, 210, 255)" }}
      ></div>
    </motion.div>
  );
};

export default Contact;
